<template>
  <header class="flex flex-col items-center justify-center bg-cover bg-center bg-no-repeat" style="background-color: #3F403E;">
    <div class="w-full">
      <div class="px-5 py-20 flex flex-col items-center max-h-full">
        <img class="max-h-full object-contain lg:w-8/12 md:w-9/12 sm:w-10/12 " src="@/assets/logo.png"/>
      </div>
    </div>
  </header>
</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },
}

</script>